import { LinearProgress } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { API } from '~/api';
import { AppRoutes } from '~/app/app.routes';
import { AuthService } from '~/service/service.auth';
import { PartnerService } from '~/service/service.partner';
import { UIService } from '~/service/service.ui';
import { useService } from '~/shared/service/service.base';
import { ActionsColumn, AvatarColumn, useGridColumns } from '~/view/grid/grid.columns';
import { GridContainer } from '~/view/grid/grid.container';
import { GridNoRows } from '~/view/grid/grid.norows';
import { MuiGridPagination } from '~/view/grid/grid.pagination';
import { GridToolbarView } from '~/view/grid/grid.toolbar';

export const PartnerListPage = observer(() => {
	const [partners, ui, auth] = useService(PartnerService, UIService, AuthService);
	const columns = useGridColumns<API.Partner>(() => [
		AvatarColumn({ field: 'avatar', headerName: 'Avatar' }),
		{ field: 'id', headerName: 'ID' },
		{ field: 'name', headerName: 'Name', minWidth: 200 },
		ActionsColumn({
			editRoute: AppRoutes.PartnerEdit.buildPath,
			onDelete: partners.delete,
			permission: 'partner',
		}),
	]);

	ui.usePageTitle('Partners');
	useEffect(() => partners.loacdAndSubscribe(), [partners]);

	return (
		<GridContainer async={partners.async}>
			<DataGrid
				initialState={partners.gridState.initial()}
				loading={partners.async.loading}
				rowCount={partners.totalCount}
				rows={partners.items.slice()}
				columns={columns}
				disableColumnFilter
				paginationMode="server"
				sortingMode="server"
				onStateChange={partners.gridState.onStateChange}
				slots={{
					loadingOverlay: LinearProgress,
					noRowsOverlay: () => <GridNoRows>No partners found</GridNoRows>,
					pagination: MuiGridPagination,
					toolbar: () => (
						<GridToolbarView
							onReload={partners.reload}
							gridState={partners.gridState}
							exportEnabled={auth.can('partner', 'EXPORT')}
						/>
					),
				}}
			/>
		</GridContainer>
	);
});
